class PopupsQueue {
    constructor() {
        this.queue = [];
        this.current = null;
        this.init();
    }

    init() {
        // Initialize event listener once
        document.addEventListener('modal-close', () => {
            this.next()
        });
        
        return this;
    }

    add(popup) {
        if (popup instanceof NodeList) {
            popup.forEach(p => this.queue.push(p));
        } else {
            this.queue.push(popup);
        }
        console.log('this.queue 2222', this.queue)
        return this;
    }

    next() {
        console.log('this.queue', this.queue)
        console.log('this.current', this.current)
        if (this.queue.length > 0) {
            this.current = this.queue.shift();
            console.log('this.current 2', this.current)
            this.current.dispatchEvent(new Event('open'));
        }
        return this;
    }
}

// Initialize queue
const queue = new PopupsQueue();
queue.add(document.querySelectorAll('.modal-in-queue')).next();